<template>
  <div>
    <v-client-table :columns="columns" :data="usersWithId" :options="options" :theme="theme" id="dataTable">
      <div slot="afterLimit" class="card-header-actions">
        <download-excel
          class   = "btn btn-default"
          type    = "csv"
          name    = "admins.xls"
          :data   = "users">
            <i class="fa fa-file-excel-o"></i>
        </download-excel>
      </div>      
      <b-button pill variant="outline-light" size="sm" slot="delete" slot-scope="props" @click.stop="confirmDelete(props.row)">
        <i class="fa fa-trash"></i>
      </b-button>
      <div slot="child_row" slot-scope="props">
        User ID : {{props.row.id}}
      </div>
    </v-client-table>

    <b-modal title="Modal title" class="modal-warning" v-model="warningModal" @ok="deleteItem" ok-variant="warning">
      It will delete only admins collection not FireAuth. Are you sure to delete?
    </b-modal>
  </div>
</template>

<script>
  import { ClientTable, Event } from 'vue-tables-2'
  import downloadexcel from 'vue-json-excel'

  export default {
    name: 'Admins',
    components: {
      ClientTable,
      Event,
      downloadexcel
    },
    data: function() {
      return {
        idToDelete : null,
        warningModal: false,
        users: [],
        columns: ['email', 'created', 'delete'],
        options: {
          headings: {
            email: 'E Mail',
            created: 'created',
            delete: 'Delete'
          },
          sortable: ['email', 'created'],
          filterable: ['email', 'created'],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          templates: {
            created: (h, row, index) => {
                return (row.created && row.created.seconds) ?this.$moment.unix(row.created.seconds).format('YYYY-MM-DD HH:mm:ss'): '';
            },
          },
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default'
      }
    },
    created: function() {
      let query = this.$firebase.firestore().collection('admins')
      this.$bind('users', query)
    },    
    computed: {
        usersWithId() {
            if (!this.users) {
                return []
            }
            return this.users.map(user => {
                return {...user, id: user.id}
            })
        }
    },
    methods: {
        confirmDelete(item) {
          if (!item) {
            return
          }
          this.idToDelete = item.id
          this.warningModal = true
        },
        async deleteItem() {
          if (!this.idToDelete) return

          try {
            await this.$firebase.firestore().collection('admins').doc(this.idToDelete).delete()
          } catch(error)  {
            console.error('delete error: ', error)
          }

          this.warningModal = false
        }
    }
  };
</script>

<style lang="scss">
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
